<template>
  <div class="renderPage animate-fade-in">
    <v-toolbar color="transparent" dark elevation="0" dense class="mb-2 premium-toolbar rounded-lg">
      <v-spacer />
      <v-toolbar-title class="text-h6 font-weight-bold tracking-tight">
        {{ formTitle }}
      </v-toolbar-title>
      <v-spacer />
    </v-toolbar>

    <!-- <v-container> -->
    <v-row dense>
      <!-- Panel de Sorteo e Información -->
      <v-col cols="12" class="mb-1">
        <v-card class="elevation-1 rounded-xl overflow-hidden glass-card theme-aware-card">
          <v-card-text class="pa-2">
            <v-row dense align="center">
              <v-col cols="12" md="4" sm="6">
                <v-select :label="sorteoTitle" item-text="descripcion" item-value="id" v-model="editedItem.idSorteo"
                  :items="sorteos" @change="onSelectedCategory" outlined dense hide-details class="rounded-lg custom-input font-weight-bold"></v-select>
              </v-col>
              <v-col cols="12" md="3" sm="6" class="d-flex align-center justify-center">
                <div class="timer-display py-1 px-4 rounded-pill d-flex align-center">
                  <v-icon class="mr-2" color="blue" size="20">mdi-clock-outline</v-icon>
                  <span class="text-h6 font-weight-black">{{ formattedTime }}</span>
                </div>
              </v-col>
              <v-col cols="12" md="3" sm="8">
                <v-text-field v-model="restringidos" label="Números Restringidos" class="text-input-blue rounded-lg custom-input" @change="changeValueComponent"
                  outlined readonly dense hide-details prepend-inner-icon="mdi-alert-circle-outline"></v-text-field>
              </v-col>
              <v-col cols="12" md="2" sm="4" class="d-flex justify-end">
                <v-checkbox v-model="formatoMas" color="success" label="Formato +" outlined dense hide-details class="mt-0 pt-0"></v-checkbox>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Panel de Registro de Jugada -->
      <v-col cols="12" md="8">
        <v-card class="elevation-1 rounded-xl glass-card theme-aware-card mb-2">
          <v-card-text class="px-3 pt-1 pb-2">
            <v-row dense>
              <v-col cols="12" sm="6" md="4">
                <v-text-field label="Repetir de Ticket #" v-model="idJugada" class="rounded-lg custom-input" outlined dense @input="changeText"
                  hide-details prepend-inner-icon="mdi-history">
                  <v-icon slot="append" @click="repetirJugada" v-if="iconVisible" color="primary">
                    mdi-magnify
                  </v-icon>
                </v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field v-model="editedItem.nombre" label="Nombre del Cliente" @change="changeValueComponent"
                  @input="changeValueComponent" outlined dense hide-details class="rounded-lg custom-input customer-name-field" prepend-inner-icon="mdi-account-outline"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field inputmode="numeric" v-model="editedItem.numeros" label="Número a Jugar" @change="changeValueComponent"
                  ref="numerosFocus" @input="handleInput" @keypress="onlyNumber" outlined dense hide-details class="rounded-lg custom-input font-weight-bold"
                  prepend-inner-icon="mdi-numeric-sign"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4">
                <v-text-field inputmode="numeric" v-model="editedItem.monto" :label="apuestaTitle" step="any"
                  class="right-input rounded-lg custom-input" @change="changeValueComponent" @keypress="onlyNumber" ref="apuestaFocus"
                  @focus="$event.target.select()" outlined dense hide-details prepend-inner-icon="mdi-cash"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" v-if="visibleReventado">
                <v-text-field v-model="editedItem.montoReventado" label="Monto Reventado" step="any"
                  min="0" class="right-input rounded-lg custom-input" @keypress="onlyNumber" @change="changeValueComponent"
                  @input="changeValueComponent" @focus="$event.target.select()" outlined dense hide-details prepend-inner-icon="mdi-fire"></v-text-field>
              </v-col>

              <v-col cols="12" sm="6" md="4" class="d-flex align-center">
                <v-checkbox v-model="editedItem.desorden" label="Modo Desorden" v-if="visibleMonazos" @change="changeValueComponent" hide-details class="mt-0"></v-checkbox>
                <v-spacer></v-spacer>
                <v-btn color="primary" fab small depressed dark @click="mostrarInformacionAdicional" class="rounded-lg elevation-2 premium-fab-mini">
                  <v-icon size="18">mdi-auto-fix</v-icon>
                </v-btn>
                <v-tooltip bottom v-if="!formatoMas">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn color="success" fab small depressed dark v-bind="attrs" v-on="on" @click="generarGalloTapado" 
                      class="ml-4 rounded-lg elevation-2 premium-gallo-btn-green">
                      <v-icon size="18">mdi-clover</v-icon>
                    </v-btn>
                  </template>
                  <span>Gallo Tapado (Suerte)</span>
                </v-tooltip>
              </v-col>

              <v-col cols="12" class="d-flex justify-center py-0">
                <v-btn color="success" @click="validarNumeros()" class="rounded-xl premium-btn-add px-12 py-3 mt-0 mb-3" depressed>
                  <v-icon left size="20"> mdi-plus-circle-outline </v-icon>
                  <span class="text-button font-weight-bold">Agregar a la Lista</span>
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>

        <!-- Tabla de Números -->
        <v-data-table id="mytable" hide-default-footer :headers="headers" :items="numeros" :items-per-page="-1"
          class="elevation-1 rounded-xl modern-table theme-aware-card border-all">
          <template v-slot:top>
            <div class="px-4 py-1 border-bottom d-flex align-center">
              <span class="text-caption font-weight-bold">Números en este Tiquete</span>
              <v-spacer></v-spacer>
              <v-chip x-small label color="blue lighten-4" class="blue--text font-weight-bold">{{ numeros.length }} items</v-chip>
            </div>
          </template>
          <template v-slot:[`item.actions`]="{ item }">
            <v-btn icon x-small @click="deleteItem(item)">
              <v-icon color="red lighten-1" size="20">mdi-trash-can-outline</v-icon>
            </v-btn>
          </template>
          <template v-slot:no-data>
            <div class="pa-10 text-center text-medium-emphasis">
              <v-icon size="48" color="grey lighten-2">mdi-ticket-outline</v-icon>
              <div class="mt-2 text-body-2">Aún no has agregado números a este tiquete</div>
            </div>
          </template>
        </v-data-table>
      </v-col>

      <!-- Panel de Resumen y Acción Final -->
      <v-col cols="12" md="4">
        <v-card class="elevation-1 rounded-xl glass-card theme-aware-card sticky-panel">
          <v-card-text class="pa-3">
            <div class="text-overline mb-2 grey--text font-weight-bold">Resumen de Venta</div>
            
            <div class="total-big-display pa-3 rounded-xl mb-3 text-center">
              <div class="text-caption text-uppercase font-weight-bold mb-1 opacity-70">Total del Tiquete</div>
              <div class="text-h4 font-weight-black primary--text">₡{{ editedItem.total }}</div>
            </div>

            <v-list dense flat class="transparent mb-4">
              <v-list-item class="px-0 min-height-dense">
                <v-list-item-content class="py-1">
                  <v-list-item-title class="grey--text text-body-2">Cliente</v-list-item-title>
                </v-list-item-content>
                <v-list-item-action class="font-weight-bold text-truncate my-0" style="max-width: 150px;">{{ editedItem.nombre || 'General' }}</v-list-item-action>
              </v-list-item>
            </v-list>

            <v-btn color="primary" @click="preSave()" v-if="visibleGenerar" :loading="loading" :disabled="loading || numeros.length === 0"
              class="rounded-xl premium-btn-generate py-6" block depressed large>
              <v-icon left size="24"> mdi-check-decagram </v-icon>
              <div class="text-left ml-2">
                <div class="text-button font-weight-black line-height-1">VENDER TIQUETE</div>
                <div class="text-caption opacity-80 font-weight-bold">Confirmar y registrar</div>
              </div>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-col>

      <v-dialog persistent transition="dialog-bottom-transition" v-model="dialogReport" max-width="380">
        <div v-if="showNewData">
          <Tiquete v-bind:allwedOnly="true" v-bind:tiqueteInfo="tiqueteInfo" @clicked="getTiqueteJugadaDesdeReporte"
            @closed="closed" />
        </div>
      </v-dialog>

      <v-dialog v-model="dialogInformacionAdicional" max-width="450px" transition="dialog-bottom-transition" overlay-opacity="0.8">
        <v-card class="rounded-xl overflow-hidden glass-card theme-aware-card">
          <v-card-title class="premium-toolbar py-4 px-6 d-flex align-center">
            <v-icon color="white" class="mr-3">mdi-auto-fix</v-icon>
            <span class="text-h6 font-weight-bold white--text">Agregar Números</span>
            <v-spacer></v-spacer>
            <v-btn icon dark x-small @click="closed">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-card-title>

          <v-card-text class="pa-4 pt-6">
            <!-- Sección Parejitas -->
            <div class="d-flex align-center mb-2">
              <v-icon small color="primary" class="mr-2">mdi-checkbox-multiple-marked-outline</v-icon>
              <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2">PAREJITAS</span>
            </div>
            <v-row dense align="center" class="mb-6">
              <v-col cols="7">
                <v-text-field v-model="montoAdicional" :label="apuestaTitle" outlined dense hide-details prepend-inner-icon="mdi-cash"
                  class="rounded-lg custom-input" type="number" inputmode="numeric"></v-text-field>
              </v-col>
              <v-col cols="5">
                <v-btn color="primary" block depressed @click="GetParejitas" :disabled="incluirValid" class="rounded-lg font-weight-bold">
                  GENERAR
                </v-btn>
              </v-col>
            </v-row>

            <v-divider class="mb-6 opacity-50"></v-divider>

            <!-- Sección Rango -->
            <div class="d-flex align-center mb-2">
              <v-icon small color="primary" class="mr-2">mdi-arrow-expand-horizontal</v-icon>
              <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2">RANGO</span>
            </div>
            <v-row dense class="mb-6">
              <v-col cols="4">
                <v-text-field inputmode="numeric" v-model="desde" label="Desde" outlined dense hide-details class="rounded-lg custom-input"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-text-field inputmode="numeric" v-model="hasta" label="Hasta" outlined dense hide-details class="rounded-lg custom-input"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-btn color="primary" block depressed @click="GetRango" class="rounded-lg font-weight-bold">
                  GENERAR
                </v-btn>
              </v-col>
            </v-row>

            <v-divider class="mb-6 opacity-50"></v-divider>

            <!-- Sección Terminación -->
            <div class="d-flex align-center mb-2">
              <v-icon small color="primary" class="mr-2">mdi-format-text-wrapping-wrap</v-icon>
              <span class="text-subtitle-2 font-weight-bold grey--text text--darken-2">TERMINACIÓN</span>
            </div>
            <v-row dense>
              <v-col cols="4">
                <v-text-field inputmode="numeric" v-model="numeroModo" label="Número" outlined dense hide-details class="rounded-lg custom-input"></v-text-field>
              </v-col>
              <v-col cols="4">
                <v-select v-model="modoComboBox" :items="items" label="Modo" outlined dense hide-details class="rounded-lg custom-input"></v-select>
              </v-col>
              <v-col cols="4">
                <v-btn color="primary" block depressed @click="GetNumerosModo" :disabled="incluirValid" class="rounded-lg font-weight-bold">
                  GENERAR
                </v-btn>
              </v-col>
            </v-row>
          </v-card-text>

          <v-divider></v-divider>
          <v-card-actions class="pa-4">
            <v-spacer></v-spacer>
            <v-btn color="error" depressed @click="closed" class="rounded-lg px-6 font-weight-bold">
              <v-icon left small>mdi-close</v-icon>
              CERRAR
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog -->
      <v-dialog v-model="dialogAtencion" max-width="500">
        <v-card>
          <v-card-title class="red--text">Atención!!!</v-card-title>
          <v-card-text> {{ atencion }}
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="dialogAtencion = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- Dialog -->
      <v-dialog v-model="dialogInfo" max-width="500">
        <v-card>
          <v-card-title class="red--text">Licencia expirada</v-card-title>
          <v-card-text>
            Estimado cliente su plan ha caducado, favor ponerse en contacto con el equipo de BestOne Solutions
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="error" @click="dialogInfo = false">Cerrar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

    </v-row>
    <!-- </v-container> -->
    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import axios from "axios";
import Tiquete from "./Tiquete.vue";
import Snackbar from "./shared/Snackbar.vue";

export default {
  components: {
    Snackbar,
    Tiquete,
  },
  dark: true,
  data() {
    return {
      headersNormal: [
        {
          text: "Numero",
          align: "start",
          value: "numero",
          class: "blue lighten-1",
        },
        {
          text: "Monto",
          align: "start",
          value: "monto",
          class: "blue lighten-1",
        },
        { text: "Eliminar", value: "actions", width: 50, sortable: false, class: "blue lighten-1" },
      ],
      headersReventados: [
        {
          text: "Numero",
          align: "start",
          value: "numero",
          class: "blue lighten-1",
        },
        {
          text: "Monto",
          align: "start",
          value: "monto",
          class: "blue lighten-1",
        },
        {
          text: "Monto Reventado",
          align: "start",
          value: "montoReventado",
          class: "blue lighten-1",
        },
        { text: "Eliminar", value: "actions", width: 50, sortable: false, class: "blue lighten-1" },
      ],
      headers: [],
      visibleReventado: false,
      visibleGenerar: false,
      visibleMonazos: false,
      loading: false,
      dialog: false,
      formatoMas: false,
      snackText: "",
      snackValue: false,
      dialogReport: false,
      activo: false,
      dialogInfo: false,
      dialogAtencion: false,
      showNewData: false,
      iconVisible: false,
      isRepetirJugada: false,
      dialogInformacionAdicional: false,
      timer: null,
      editedIndex: -1,
      sorteos: [],
      numeros: [],
      tiqueteReport: [],
      items: ['Inicial', 'Termina'],
      idJugada: "",
      oldSorteoId: 0,
      desde: 0,
      hasta: 0,
      numeroModo: 0,
      modoComboBox: "Inicial",
      rango: "",
      modo: "",
      parejitas: "",
      montoAdicional: 0,
      atencion: "",
      atencionBandera: false,
      tiqueteInfo: {
        idTiquete: "",
        tipoTiquete: "",
      },
      licenciaValida: [],
      respuestaNumeros: {
        valido: false,
        error: "",
        total: 0,
        numerosSorteos: [],
      },
      detalleditedIndex: -1,
      restringidos: "",
      numValidos: "",
      defaultItem: {
        id: 0,
        idSorteo: 0,
        monto: 0,
        numeros: "",
        cancelado: false,
        idUsuario: "",
        Fecha: new Date().toISOString().slice(0, 10),
        numerosSorteos: [],
        companyId: "",
        montoReventado: 0,
        desorden: false,
        nombre: "",
      },
      editedItem: {
        id: 0,
        idSorteo: 0,
        monto: 0,
        numeros: "",
        cancelado: false,
        idUsuario: "",
        Fecha: new Date().toISOString().slice(0, 10),
        numerosSorteos: [],
        companyId: "",
        montoReventado: 0,
        desorden: false,
        nombre: "",
      },
      nameRules: [(v) => !!v || "Campo requerido"],
      timeLeft: this.getTimeLeft(),
      interval: null,
      fechaSorteo: new Date(),
    };
  },

  mounted() {
    this.$nextTick(() => {
      this.focusInput();
    });
    this.interval = setInterval(this.updateTime, 1000);
  },

  beforeDestroy() {
    clearInterval(this.interval);
  },

  computed: {
    ...mapGetters(["user", "strCia"]),
    formTitle() {
      return this.strCia === '303650094' ? "Cashback" : "DASHBOARD TIEMPOS";
    },
    apuestaTitle() {
      return this.strCia === '303650094' ? "Monto Cashback" : "Apuesta";
    },
    sorteoTitle() {
      return this.strCia === '303650094' ? "Cashback" : "Sorteos";
    },
    formattedTime() {
      const hours = Math.floor(this.timeLeft / 3600);
      const minutes = Math.floor((this.timeLeft % 3600) / 60);
      const seconds = this.timeLeft % 60;
      return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },

    search() {
      this.snackValue = false;
    },
  },

  created() {
    this.editedItem = Object.assign({}, this.editedItem);
    this.getSorteosFirst();
    this.validarLicencia();
  },

  methods: {
    generarGalloTapado() {
      // Generar número aleatorio entre 00 y 99
      const numeroAzar = Math.floor(Math.random() * 100);
      this.editedItem.numeros = String(numeroAzar).padStart(2, "0");
      
      // Feedback visual y foco en la apuesta
      this.snackText = "¡Gallo Tapado! Número: " + this.editedItem.numeros;
      this.snackValue = true;

      // Lógica de auto-agregado si ya hay una apuesta
      const tieneApuestaNormal = this.editedItem.monto > 0;
      const tieneApuestaReventado = !this.visibleReventado || (this.visibleReventado && this.editedItem.montoReventado > 0);

      if (tieneApuestaNormal && tieneApuestaReventado) {
        this.$nextTick(() => {
          this.validarNumeros();
        });
      } else {
        this.$nextTick(() => {
          if (this.$refs.apuestaFocus) {
            this.$refs.apuestaFocus.focus();
          }
        });
      }
    },


    getSorteos() {
      let me = this;
      axios
        .get("api/Tiempos/GetSorteos?companyId=" + this.strCia)
        .then(function (response) {
          me.sorteos = response.data;
          me.getRestringidos();
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTimeLeft() {
      //const now = new Date();

      const now = new Date().toLocaleString("en-US", { timeZone: "America/Costa_Rica" });
      const nowDate = new Date(now); // Convertir a objeto Date nuevamente

      return Math.floor((this.fechaSorteo - nowDate) / 1000); // Diferencia en segundos
    },
    updateTime() {
      this.timeLeft = this.getTimeLeft();
    },

    filterNumeric() {
      // Remove all non-numeric characters from the input
      this.number = this.number.replace(/[^0-9]/g, '');
    },

    onlyNumber($event) {
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);

      if (keyCode == 13) {
        console.log("se presionó enter");
        this.validarNumeros();
      }

      // Solo permitir números (0–9) y el signo + (keyCode 43)
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 43) {
        $event.preventDefault();
      }
    },

    onlyVlidNumbers($event) {
      //console.log($event.keyCode); //keyCodes value
      let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
        $event.preventDefault();
      }
    },

    onClickOutside() {
      this.dialogReport = false;
    },

    GetRango() {
      if (this.montoAdicional > 0) {
        this.editedItem.monto = this.montoAdicional;
      }
      //this.changeValueComponent();
      const result = this.sorteos.filter(c => c.id == this.editedItem.idSorteo);

      if (this.hasta < 100) {

        let me = this;
        axios
          .get("api/Tiempos/GetRango?start=" + this.desde +
            "&end=" +
            this.hasta)
          .then(function (response) {
            if (me.editedItem.monto < 1) {
              me.editedItem.monto = "";
              me.snackText = "Debe ingresar la apuesta";
              me.snackValue = true;
            } else {
              if (result[0].categoria === 1) {
                me.rango = response.data;
                me.dialogInformacionAdicional = false;
                me.editedItem.numeros = me.rango;
                me.validarNumeros();
                me.rango = "";
                me.modo = "";
                me.parejitas = "";
              }

              if (result[0].categoria === 2) {
                if (me.editedItem.montoReventado > 0) {
                  me.rango = response.data;
                  me.dialogInformacionAdicional = false;
                  me.editedItem.numeros = me.rango;
                  me.validarNumeros();
                  me.rango = "";
                  me.modo = "";
                  me.parejitas = "";
                } else {
                  me.snackText = "Debe ingresar la apuesta reventado";
                  me.snackValue = true;
                }
              }
            }
          })
          .catch(function (error) {
            console.log(error);
          });

      } else {
        this.snackText = "El número Hasta no puede ser mayor de 99";
        this.snackValue = true;
      }
    },

    GetNumerosModo() {
      if (this.modoComboBox === "Inicial") {
        this.GetInicial();
      }

      if (this.modoComboBox === "Termina") {
        this.GetTerminacion();
      }
    },

    GetTerminacion() {
      if (this.montoAdicional > 0) {
        this.editedItem.monto = this.montoAdicional;
      }
      const result = this.sorteos.filter(c => c.id == this.editedItem.idSorteo);

      //this.changeValueComponent();
      let me = this;
      axios
        .get("api/Tiempos/GetTerminacion?number=" + this.numeroModo)
        .then(function (response) {
          if (me.editedItem.monto < 1) {
            me.editedItem.monto = "";
            me.snackText = "Debe ingresar la apuesta";
            me.snackValue = true;
          } else {

            if (result[0].categoria === 1) {
              me.modo = response.data;
              me.dialogInformacionAdicional = false;
              me.editedItem.numeros = me.modo;
              me.validarNumeros();
              me.rango = "";
              me.modo = "";
              me.parejitas = "";
            }
            if (result[0].categoria === 2) {
              if (me.editedItem.montoReventado > 0) {
                me.modo = response.data;
                me.dialogInformacionAdicional = false;
                me.editedItem.numeros = me.modo;
                me.validarNumeros();
                me.rango = "";
                me.modo = "";
                me.parejitas = "";
              } else {
                me.snackText = "Debe ingresar la apuesta reventado";
                me.snackValue = true;
              }
            }

          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    GetInicial() {
      if (this.montoAdicional > 0) {
        this.editedItem.monto = this.montoAdicional;
      }
      //this.changeValueComponent();
      const result = this.sorteos.filter(c => c.id == this.editedItem.idSorteo);

      let me = this;
      axios
        .get("api/Tiempos/GetInicial?number=" + this.numeroModo)
        .then(function (response) {
          if (me.editedItem.monto < 1) {
            me.editedItem.monto = "";
            me.snackText = "Debe ingresar la apuesta";
            me.snackValue = true;
          } else {

            if (result[0].categoria === 1) {
              me.modo = response.data;
              me.dialogInformacionAdicional = false;
              me.editedItem.numeros = me.modo;
              me.validarNumeros();
              me.rango = "";
              me.modo = "";
              me.parejitas = "";
            }

            if (result[0].categoria === 2) {
              if (me.editedItem.montoReventado > 0) {
                me.modo = response.data;
                me.dialogInformacionAdicional = false;
                me.editedItem.numeros = me.modo;
                me.validarNumeros();
                me.rango = "";
                me.modo = "";
                me.parejitas = "";
              } else {
                me.snackText = "Debe ingresar la apuesta reventado";
                me.snackValue = true;
              }
            }

          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    GetParejitas() {
      if (this.montoAdicional > 0) {
        this.editedItem.monto = this.montoAdicional;
      }
      //this.changeValueComponent();
      const result = this.sorteos.filter(c => c.id == this.editedItem.idSorteo);

      let me = this;
      axios
        .get("api/Tiempos/GetParejitas")
        .then(function (response) {
          if (me.editedItem.monto < 1) {
            me.editedItem.monto = "";
            me.snackText = "Debe ingresar la apuesta";
            me.snackValue = true;
          } else {

            if (result[0].categoria === 1) {
              me.parejitas = response.data;
              me.dialogInformacionAdicional = false;
              me.editedItem.numeros = me.parejitas;
              me.validarNumeros();
              me.rango = "";
              me.modo = "";
              me.parejitas = "";
            }

            if (result[0].categoria === 2) {

              if (me.editedItem.montoReventado > 0) {
                me.parejitas = response.data;
                me.dialogInformacionAdicional = false;
                me.editedItem.numeros = me.parejitas;
                me.validarNumeros();
                me.rango = "";
                me.modo = "";
                me.parejitas = "";
              } else {
                me.snackText = "Debe ingresar la apuesta reventado";
                me.snackValue = true;
              }
            }

          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    mostrarInformacionAdicional() {
      this.dialogInformacionAdicional = true;
      this.desde = 0;
      this.hasta = 0;
      this.numeroModo = 0;
      this.montoAdicional = this.editedItem.monto;
    },

    validarLicencia() {
      let me = this;
      axios
        .get("api/Usuarios/licenciaValidar?cia=" + this.strCia)
        .then(function (response) {
          me.licenciaValida = response.data;
          if (!me.licenciaValida.valido) {
            me.snackText = me.licenciaValida.motivo;
            me.snackValue = true;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    focusInput() {
      this.$refs.numerosFocus.focus();
    },

    focusApuestaInput() {
      this.$refs.apuestaFocus.focus();
    },

    handleInput() {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        if (this.editedItem.monto < 1) {
          this.editedItem.monto = "";
        }

        if (this.editedItem.numeros > 99) {
          this.editedItem.numeros = ""; // Minimum value
          this.snackText = "Ingrese un número valido del 00 al 99";
          this.snackValue = true;
        } else {
          console.log(this.formatoMas);
          if (!this.formatoMas) {
            this.focusApuestaInput();
          } else {
            this.editedItem.numeros = this.editedItem.numeros + "+";
          }
        }
        console.log('Text changed:', this.editedItem.numeros);
      }, 700);
    },

    getSorteosFirst() {
      let me = this;
      axios
        .get("api/Tiempos/GetSorteos?companyId=" + this.strCia)
        .then(function (response) {
          me.sorteos = response.data;
          me.editedItem.idSorteo = me.sorteos[0]["id"];
          me.fechaSorteo = new Date(me.sorteos[0]["fecha"]);
          console.log(me.fechaSorteo);
          me.timeLeft = me.getTimeLeft();
          me.getRestringidos();
          me.onSelectedCategory(me.sorteos[0]["id"]);
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getRestringidos() {
      let me = this;
      axios
        .get(
          "api/Tiempos/GetTiquetesRestringidos?idSorteo=" +
          this.editedItem.idSorteo +
          "&companyId=" +
          this.strCia,
        )
        .then(function (response) {
          me.restringidos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getRestringidosReventados() {
      let me = this;
      axios
        .get(
          "api/Tiempos/GetTiquetesReventadosRestringidos?idSorteo=" +
          this.editedItem.idSorteo +
          "&companyId=" +
          this.strCia,
        )
        .then(function (response) {
          me.restringidos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getRestringidosMonazos() {
      let me = this;
      axios
        .get(
          "api/Tiempos/GetTiquetesMonazosRestringidos?idSorteo=" +
          this.editedItem.idSorteo +
          "&companyId=" +
          this.strCia,
        )
        .then(function (response) {
          me.restringidos = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    validarNumeros() {
      const result = this.sorteos.filter(c => c.id == this.editedItem.idSorteo);
      console.log(this.licenciaValida.valido);
      if (this.licenciaValida.valido) {

        if (this.editedItem.numeros > 99) {
          this.editedItem.numeros = ""; // Minimum value
          this.snackText = "Ingrese un número valido del 00 al 99";
          this.snackValue = true;
        } else {
          if (result[0].categoria === 1) {
            //this.validarNumerosNormal();
            this.validarNumerosV2();
          }

          if (result[0].categoria === 2) {
            this.validarNumerosReventados();
          }

          if (result[0].categoria === 3) {
            this.validarNumerosMonazos();
          }
        }
      } else {
        this.dialogInfo = true;
      }
    },

    validarNumerosNormal() {
      this.changeValueComponent();
      this.editedItem.idUsuario = this.user.cedula;
      this.editedItem.numerosSorteos = this.numeros;
      this.editedItem.companyId = this.strCia;
      let me = this;
      //if (this.editedIndex > -1) {
      axios
        .post("api/Tiempos/ValidarNumerosV2", this.editedItem)
        .then(function (response) {
          me.respuestaNumeros = response.data;
          //me.respuestaNumeros = response.data;
          me.focusInput();
          if (!me.respuestaNumeros.valido) {
            me.snackText = me.respuestaNumeros.error;
            me.snackValue = true;
          } else {
            me.numeros = me.respuestaNumeros.numerosSorteos;
            me.editedItem.total = me.respuestaNumeros.total;
            me.editedItem.numeros = "";
            me.visibleGenerar = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          me.snackText = "Ha ocurrido un error inesperado";
          me.snackValue = true;
        });
      //}
    },

    validarNumerosNormalPreSave() {
      this.changeValueComponent();
      this.editedItem.idUsuario = this.user.cedula;
      this.editedItem.numerosSorteos = this.numeros;
      this.editedItem.companyId = this.strCia;
      let me = this;
      //if (this.editedIndex > -1) {
      axios
        .post("api/Tiempos/ValidarNumeros", this.editedItem)
        .then(function (response) {
          me.respuestaNumeros = response.data;
          //me.respuestaNumeros = response.data;
          me.focusInput();
          if (!me.respuestaNumeros.valido) {
            me.atencionBandera = true;
            me.atencion = me.respuestaNumeros.error;
            me.dialogAtencion = true;
            me.loading = false;
            me.visibleGenerar = true;
          } else {
            me.save();
          }
        })
        .catch(function (error) {
          console.log(error);
          me.snackText = me.getErrorMessage(error);
          me.snackValue = true;
          me.loading = false;
          me.visibleGenerar = true;
        });
      //}
    },

    validarNumerosV2() {
      this.editedItem.numerosSorteos = this.numeros;
      this.respuestaNumeros = { valido: true, error: "", numerosSorteos: [], total: 0 };

      // Validar monto que termine en 0 o 50
      if (!this.avoidTermination(parseInt(this.editedItem.monto))) {
        this.respuestaNumeros.error = "El monto a vender debe finalizar en 0 ó 50";
        this.respuestaNumeros.valido = false;
      }

      // Validar usuario
      if (!this.user.cedula) {
        this.respuestaNumeros.error = "Por favor inicie sesión para generar un tiquete";
        this.respuestaNumeros.valido = false;
      }

      let numerosSorteo = [];

      // Separar y limpiar entrada
      const numerosIngresados = this.editedItem.numeros
        .split("+")
        .map(num => num.trim())
        .filter(num => num); // eliminar vacíos

      // Validar rango de cada número
      for (let num of numerosIngresados) {
        if (isNaN(num) || Number(num) < 0 || Number(num) > 99) {
          this.respuestaNumeros.error = `El número ${num} no es válido. Solo se permiten valores entre 0 y 99.`;
          this.respuestaNumeros.valido = false;
          break;
        }
      }

      // Si hay error, mostrar y detener
      if (!this.respuestaNumeros.valido) {
        this.snackText = this.respuestaNumeros.error;
        this.snackValue = true;
        return;
      }

      // Agregar números ingresados manualmente
      numerosIngresados.forEach(num => {
        numerosSorteo.push({ numero: num, monto: this.editedItem.monto.toString() });
        this.respuestaNumeros.total += parseFloat(this.editedItem.monto);
      });

      // Agregar números ya existentes en this.numeros
      if (this.numeros.length > 0) {
        this.numeros.forEach(respuesta => {
          numerosSorteo.push({ numero: respuesta.numero, monto: respuesta.monto });
          this.respuestaNumeros.total += parseFloat(respuesta.monto);
        });
      }

      // Agrupar y sumar
      this.respuestaNumeros.numerosSorteos = this.groupAndSum(numerosSorteo);

      // Preparar UI
      this.focusInput();
      this.numeros = this.respuestaNumeros.numerosSorteos;
      this.editedItem.total = this.respuestaNumeros.total;
      this.editedItem.numeros = "";
      this.visibleGenerar = true;
    },

    avoidTermination(number) {
      let lastTwoDigits = number % 100;
      return lastTwoDigits === 50 || lastTwoDigits === 0;
    },

    groupAndSum(numerosSorteos) {
      // Agrupar por 'numero' y sumar 'monto'
      let grouped = numerosSorteos.reduce((acc, curr) => {
        let found = acc.find(item => item.numero === curr.numero);
        if (found) {
          found.monto = (parseFloat(found.monto) + parseFloat(curr.monto)).toString();
        } else {
          acc.push({ numero: curr.numero, monto: curr.monto.toString() });
        }
        return acc;
      }, []);

      return grouped;
    },

    validarNumerosReventados() {
      this.changeValueComponent();
      this.editedItem.idUsuario = this.user.cedula;
      this.editedItem.numerosSorteos = this.numeros;
      this.editedItem.companyId = this.strCia;
      let me = this;
      axios
        .post("api/Tiempos/ValidarNumerosReventados", this.editedItem)
        .then(function (response) {
          me.respuestaNumeros = response.data;
          me.focusInput();
          if (!me.respuestaNumeros.valido) {
            me.snackText = me.respuestaNumeros.error;
            me.snackValue = true;
          } else {
            me.numeros = me.respuestaNumeros.numerosSorteos;
            me.editedItem.total = me.respuestaNumeros.total;
            me.editedItem.numeros = "";
            me.visibleGenerar = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          me.snackText = "Ha ocurrido un error inesperado";
          me.snackValue = true;
        });
    },

    validarNumerosMonazos() {
      this.changeValueComponent();
      this.editedItem.idUsuario = this.user.cedula;
      this.editedItem.numerosSorteos = this.numeros;
      this.editedItem.companyId = this.strCia;
      let me = this;
      axios
        .post("api/Tiempos/ValidarNumerosMonazos", this.editedItem)
        .then(function (response) {
          me.respuestaNumeros = response.data;
          if (!me.respuestaNumeros.valido) {
            me.snackText = me.respuestaNumeros.error;
            me.snackValue = true;
          } else {
            me.numeros = me.respuestaNumeros.numerosSorteos;
            me.editedItem.total = me.respuestaNumeros.total;
            me.editedItem.numeros = "";
            me.visibleGenerar = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          me.snackText = "Ha ocurrido un error inesperado";
          me.snackValue = true;
        });
    },

    changeText() {
      this.iconVisible = true;
    },

    getTiqueteReport() {
      this.dialogReport = true;
      this.showNewData = true;
    },

    repetirJugada() {
      const result = this.sorteos.filter(c => c.id == this.editedItem.idSorteo);
      if (result[0].categoria === 1) {
        this.getTiqueteJugada();
      }

      if (result[0].categoria === 2) {
        this.getJugadaReventadoDesdeReporte();
      }

      if (result[0].categoria === 3) {
        this.validarNumerosMonazos();
      }

    },

    getTiqueteJugada() {
      this.snackValue = false;
      let me = this;
      axios
        .get("api/Tiempos/GetTiqueteReport?idTiquete=" + this.idJugada +
          "&companyId=" +
          this.strCia +
          "&reimpresion=" +
          this.tiqueteInfo.reimpresion)
        .then(function (response) {
          me.tiqueteReport = response.data;
          //me.editedItem.numeros = me.tiqueteReport.numDetalles;
          me.editedItem.monto = me.tiqueteReport.monto;
          me.editedItem.nombre = me.tiqueteReport.nombre;
          me.editedItem.total = me.tiqueteReport.total;
          //me.editedItem.numerosSorteos = me.tiqueteReport.numerosSorteos;
          me.editedItem.montoReventado = 0;
          me.numeros = me.tiqueteReport.numerosSorteos;
          me.visibleGenerar = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getJugadaReventadoDesdeReporte() {
      this.snackValue = false;
      this.showNewData = false;
      this.dialogReport = false;
      this.isRepetirJugada = true;
      let me = this;
      axios
        .get("api/Tiempos/GetTiqueteReventadoReport?idTiquete=" + this.idJugada +
          "&companyId=" +
          this.strCia +
          "&reimpresion=" +
          this.tiqueteInfo.reimpresion)
        .then(function (response) {
          me.tiqueteReport = response.data;
          //me.editedItem.numeros = me.tiqueteReport.numDetalles;
          me.editedItem.monto = me.tiqueteReport.monto;
          me.editedItem.montoReventado = me.tiqueteReport.montoReventado;
          me.editedItem.nombre = me.tiqueteReport.nombre;
          me.editedItem.total = me.tiqueteReport.total;
          //me.editedItem.numerosSorteos = me.tiqueteReport.numerosSorteos;
          me.numeros = me.tiqueteReport.numerosSorteos;
          me.visibleGenerar = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getTiqueteJugadaDesdeReporte() {
      this.snackValue = false;
      this.showNewData = false;
      this.dialogReport = false;
      this.isRepetirJugada = true;
      let me = this;
      axios
        .get("api/Tiempos/GetTiquete" + this.tiqueteInfo.tipoTiquete + "Report?idTiquete=" + this.tiqueteInfo.idTiquete +
          "&companyId=" +
          this.strCia +
          "&reimpresion=" +
          this.tiqueteInfo.reimpresion)
        .then(function (response) {
          me.tiqueteReport = response.data;
          //me.editedItem.numeros = me.tiqueteReport.numDetalles;
          me.editedItem.monto = me.tiqueteReport.monto;
          me.editedItem.montoReventado = me.tiqueteReport.montoReventado;
          me.editedItem.nombre = me.tiqueteReport.nombre;
          me.editedItem.total = me.tiqueteReport.total;
          //me.editedItem.numerosSorteos = me.tiqueteReport.numerosSorteos;
          me.numeros = me.tiqueteReport.numerosSorteos;
          me.visibleGenerar = true;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    changeValueComponent() {
      this.snackValue = false;
    },

    onSelectedCategory(id) {
      const result = this.sorteos.filter(c => c.id == id);

      this.fechaSorteo = new Date(result[0].fecha);
      console.log(this.fechaSorteo);
      this.timeLeft = this.getTimeLeft();

      if (result[0].categoria === 1) {
        this.restringidos = "";
        this.getRestringidos();
        this.visibleReventado = false;
        this.visibleMonazos = false;
        this.headers = this.headersNormal;
      }

      if (result[0].categoria === 2) {
        this.restringidos = "";
        this.getRestringidosReventados();
        this.visibleReventado = true;
        this.visibleMonazos = false;
        this.headers = this.headersReventados;
      }

      if (result[0].categoria === 3) {
        this.restringidos = "";
        this.getRestringidosMonazos();
        this.visibleReventado = false;
        this.visibleMonazos = true;
        this.headers = this.headersNormal;
      }

      if (!this.isRepetirJugada) {
        this.editedItem.numeros = "";
        this.editedItem.monto = 0;
        this.editedItem.total = 0;
        this.editedItem.montoReventado = 0;
        this.idJugada = "";
        this.numeros = [];
        this.editedItem.nombre = "";
      } else {
        this.idJugada = "";
      }
    },

    closed() {
      if (this.dialogInformacionAdicional && this.montoAdicional > 0) {
        this.editedItem.monto = this.montoAdicional;
      }
      this.snackValue = false;
      this.showNewData = false;
      this.dialogReport = false;
      this.dialogInformacionAdicional = false;
    },

    getErrorMessage(error) {
      if (!error.response) {
        return "Error de conexión: Por favor verifique su internet.";
      }
      return "Error del servidor: No se pudo procesar la solicitud.";
    },

    deleteItem(item) {
      this.detalleEditedIndex = this.numeros.indexOf(item);
      console.log(this.detalleEditedIndex);
      if (confirm("¿Está seguro de que desea eliminar número de la lista?")) {
        this.numeros.splice(this.detalleEditedIndex, 1);
        this.editedItem.numerosSorteos = this.numeros;
        this.validarNumeros();
      }
    },

    preSave() {
      if (this.loading) return;
      this.loading = true;
      this.visibleGenerar = false;

      let me = this;

      axios
        .get("api/Usuarios/UsuarioActivo?cedula=" + this.user.cedula)
        .then(function (response) {
          me.activo = response.data;
          console.log(me.activo);
          if (me.activo) {
            const result = me.sorteos.filter(c => c.id == me.editedItem.idSorteo);
            if (result[0].categoria === 1) {
              me.validarNumerosNormalPreSave();
              //this.save();
            }

            if (result[0].categoria === 2) {
              me.saveReventados();
            }

            if (result[0].categoria === 3) {
              me.saveMonazos();
            }
          } else {
            me.snackText = "El usuario se encuentra Inactivo.";
            me.snackValue = true;
            me.loading = false;
            me.visibleGenerar = true;
          }
        })
        .catch(function (error) {
          console.log(error);
          me.snackText = me.getErrorMessage(error);
          me.snackValue = true;
          me.loading = false;
          me.visibleGenerar = true;
        });
    },

    save() {
      //this.snackValue = false;
      this.editedItem.idUsuario = this.user.cedula;
      this.editedItem.numerosSorteos = this.numeros;
      this.editedItem.companyId = this.strCia;
      //var oldSorteoId = this.editedItem.idSorteo;
      let me = this;

      if (this.numeros.length < 1) {
        me.snackText = "Por favor seleccione los números a vender";
        me.snackValue = true;
        me.loading = false;
        me.visibleGenerar = true;
      } else {
        axios
          .post("api/Tiempos/InsertTiquetes", this.editedItem)
          .then(function (response) {
            me.tiqueteInfo.idTiquete = response.data;
            me.tiqueteInfo.tipoTiquete = "";
            if (me.tiqueteInfo.idTiquete > 0) {
              me.snackText =
                "Se ha registrado el tiquete #" +
                response.data +
                " correctamente";
              me.snackValue = true;
              me.editedItem.numeros = "";
              me.editedItem.nombre = "";
              me.editedItem.monto = 0;
              me.editedItem.total = 0;
              me.editedItem.montoReventado = 0;
              me.idJugada = "";
              me.numeros = [];
              me.restringidos = "";
              me.isRepetirJugada = false;
              me.getTiqueteReport();
              me.getSorteos();
              me.focusInput();
            } else {
              me.snackText =
                "No se pudo crear el tiquete debido a un error inesperado. Por favor, comuníquese con el soporte técnico.";
              me.snackValue = true;
              me.visibleGenerar = true;
            }
            me.loading = false;
          })
          .catch(function (error) {
            console.log(error);
            me.snackText = me.getErrorMessage(error);
            me.snackValue = true;
            me.loading = false;
            me.visibleGenerar = true;
          });
      }
    },
    saveReventados() {
      //this.snackValue = false;
      this.editedItem.idUsuario = this.user.cedula;
      this.editedItem.numerosSorteos = this.numeros;
      this.editedItem.companyId = this.strCia;
      let me = this;

      if (this.numeros.length < 1) {
        me.snackText = "Por favor seleccione los números a vender";
        me.snackValue = true;
        me.loading = false;
        me.visibleGenerar = true;
      } else {
        axios
          .post("api/Tiempos/InsertTiquetesReventado", this.editedItem)
          .then(function (response) {
            me.tiqueteInfo.idTiquete = response.data;
            me.tiqueteInfo.tipoTiquete = "Reventado";
            me.snackText =
              "Se ha registrado el tiquete #" +
              response.data +
              " correctamente";
            me.snackValue = true;
            me.editedItem.numeros = "";
            me.editedItem.nombre = "";
            me.editedItem.monto = 0;
            me.editedItem.montoReventado = 0;
            me.editedItem.total = 0;
            me.idJugada = "";
            me.numeros = [];
            me.restringidos = "";
            me.isRepetirJugada = false;
            me.getTiqueteReport();
            me.getSorteos();
            me.loading = false;
          })
          .catch(function (error) {
            console.log(error);
            me.snackText = me.getErrorMessage(error);
            me.snackValue = true;
            me.loading = false;
            me.visibleGenerar = true;
          });
      }
    },
    saveMonazos() {
      //this.snackValue = false;
      this.editedItem.idUsuario = this.user.cedula;
      this.editedItem.numerosSorteos = this.numeros;
      this.editedItem.companyId = this.strCia;
      let me = this;

      if (this.numeros.length < 1) {
        me.snackText = "Por favor seleccione los números a vender";
        me.snackValue = true;
        me.loading = false;
        me.visibleGenerar = true;
      } else {
        axios
          .post("api/Tiempos/InsertTiquetesMonazos", this.editedItem)
          .then(function (response) {
            me.tiqueteInfo.idTiquete = response.data;
            me.tiqueteInfo.tipoTiquete = "Monazo";
            me.snackText =
              "Se ha registrado el tiquete #" +
              response.data +
              " correctamente";
            me.snackValue = true;
            me.editedItem.numeros = "";
            me.editedItem.nombre = "";
            me.editedItem.monto = 0;
            me.editedItem.total = 0;
            me.editedItem.montoReventado = 0;
            me.idJugada = "";
            me.numeros = [];
            me.restringidos = "";
            me.isRepetirJugada = false;
            me.getTiqueteReport();
            me.getSorteos();
            me.loading = false;
          })
          .catch(function (error) {
            console.log(error);
            me.snackText = me.getErrorMessage(error);
            me.snackValue = true;
            me.loading = false;
            me.visibleGenerar = true;
          });
      }
    },
  },
};
</script>

<style>
/* Ultra-Premium UI Phase 2 - Theme Aware */
@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700&display=swap');

.renderPage {
  font-family: 'Inter', -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif !important;
  min-height: 100vh;
  padding: 16px;
  transition: background-color 0.3s ease;
}

/* Page background handling */
.renderPage {
  padding-top: 0px !important;
  margin-top: -15px !important;
}

.theme--light.renderPage {
  background-color: #f1f5f9 !important;
}
.theme--dark.renderPage {
  background-color: #0f172a !important;
}

/* Elite Layout Components */
.glass-card {
  backdrop-filter: blur(8px) !important;
  -webkit-backdrop-filter: blur(8px) !important;
  border: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.theme--light .theme-aware-card {
  background-color: rgba(255, 255, 255, 0.9) !important;
  border: 1px solid #e2e8f0 !important;
}

.theme--dark .theme-aware-card {
  background-color: #1e293b !important;
  border: 1px solid #334155 !important;
}

.timer-display {
  background: rgba(59, 130, 246, 0.1);
  border: 1px solid rgba(59, 130, 246, 0.2);
  color: #2563eb;
}

.theme--dark .timer-display {
  background: rgba(59, 130, 246, 0.05);
  color: #60a5fa;
}

.total-big-display {
  background: linear-gradient(135deg, rgba(37, 99, 235, 0.05) 0%, rgba(37, 99, 235, 0.1) 100%);
  border: 2px dashed rgba(37, 99, 235, 0.2);
}

.theme--dark .total-big-display {
  background: rgba(30, 41, 59, 0.5);
}

.sticky-panel {
  position: sticky;
  top: 70px;
}

.min-height-dense {
  min-height: 32px !important;
}

.opacity-70 { opacity: 0.7; }
.opacity-80 { opacity: 0.8; }
.line-height-1 { line-height: 1; }

.border-bottom {
  border-bottom: 1px solid rgba(0,0,0,0.05);
}

.theme--dark .border-bottom {
  border-bottom: 1px solid rgba(255,255,255,0.05);
}

.animate-fade-in {
  animation: fadeInUp 0.6s cubic-bezier(0.16, 1, 0.3, 1);
}

@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.premium-toolbar {
  background: linear-gradient(135deg, #2563eb 0%, #1d4ed8 100%) !important;
  border: none !important;
  box-shadow: 0 10px 15px -3px rgba(37, 99, 235, 0.2) !important;
  color: white !important;
  margin-bottom: 8px !important;
}

.premium-fab-mini {
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
}

.premium-toolbar .v-toolbar__title {
  color: white !important;
  text-shadow: 0 2px 4px rgba(0,0,0,0.2);
}

/* Input handling for Light/Dark Mode */
.custom-input .v-input__slot {
  transition: all 0.25s cubic-bezier(0.4, 0, 0.2, 1) !important;
  box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05) !important;
}

.theme--light .custom-input .v-input__slot {
  background: white !important;
  border: 1px solid #e2e8f0 !important;
}

.theme--dark .custom-input .v-input__slot {
  background: #1e1e1e !important;
  border: 1px solid #334155 !important;
}

.custom-input.v-input--is-focused .v-input__slot {
  border-color: #3b82f6 !important;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1) !important;
  transform: translateY(-1px);
}

/* Color suave para el Nombre del Cliente */
.theme--light .customer-name-field .v-input__slot {
  background: #f0f7ff !important; /* Azul muy pálido */
  border: 1px solid #d0e1f9 !important;
}

.theme--dark .customer-name-field .v-input__slot {
  background: rgba(59, 130, 246, 0.08) !important;
  border: 1px solid rgba(59, 130, 246, 0.2) !important;
}

.premium-btn-add {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
}

.premium-btn-add:hover {
  transform: translateY(-2px);
  box-shadow: 0 6px 16px rgba(16, 185, 129, 0.4) !important;
}

.premium-btn-generate {
  background: linear-gradient(135deg, #3b82f6 0%, #1d4ed8 100%) !important;
  box-shadow: 0 10px 25px rgba(59, 130, 246, 0.4) !important;
  transition: all 0.3s cubic-bezier(0.34, 1.56, 0.64, 1) !important;
}

.premium-btn-generate:hover {
  transform: translateY(-3px) scale(1.02);
  box-shadow: 0 15px 30px rgba(59, 130, 246, 0.5) !important;
}

.premium-gallo-btn-green {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  box-shadow: 0 4px 10px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  width: 32px !important;
  height: 32px !important;
  min-width: 32px !important;
}

.premium-gallo-btn-green:hover {
  transform: rotate(15deg) scale(1.1);
  box-shadow: 0 6px 15px rgba(16, 185, 129, 0.4) !important;
}

.modern-table {
  border-radius: 16px !important;
  overflow: hidden !important;
  border: 1px solid #e2e8f0 !important;
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}

.theme--light .modern-table .v-data-table-header th {
  background-color: #1e88e5 !important;
  color: white !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 0.85rem !important;
  letter-spacing: 0.5px;
}

.theme--dark .modern-table .v-data-table-header th {
  background-color: #1565c0 !important;
  color: white !important;
  font-weight: 700 !important;
  text-transform: uppercase;
  font-size: 0.85rem !important;
  letter-spacing: 0.5px;
}

.v-card {
  border-radius: 16px !important;
  box-shadow: 0 20px 25px -5px rgba(0, 0, 0, 0.1) !important;
}

/* Manteniendo compatibilidad con clases previas */
.right-input input {
  text-align: right;
  font-weight: 600;
}

.theme--light .right-input input {
  color: #1e293b;
}

.theme--dark .right-input input {
  color: #f8fafc;
}

.text-input-blue .v-text-field__slot input {
  color: #ef4444 !important;
  font-weight: 700;
}

.botonSalir {
  position: fixed;
  top: 15px;
  right: 15px;
  z-index: 100;
}
</style>
